import { AppFlagMapping, AppMapping, HeaderIconMapping, HeaderMapping, URLBuilders } from './common'

const SUITE_NAME = 'AUTH_ROUTING'

const SHOW_APPS_DROPDOWN = false
const SHOW_PRODUCT_DROPDOWN = false
const SHOW_NOTIFICATION_DROPDOWN = false
const SHOW_ORG_SWITCHER = false
const SHOW_ACCOUNT_SWITCHER = false
const SHOW_USER_INFO = true
const INCLUDE_BANNER_LINK = false

const HEADER_LIST = []

const HEADER_ICON_MAPPING: HeaderIconMapping = {}

const HEADER_MAPPING: HeaderMapping = {}

const URL_MAPPING: AppMapping = {}

const APP_NAME_MAPPING: AppMapping = {}

const APP_DATA_SECTION_MAPPING: AppMapping = {}

const URL_BUILDERS: URLBuilders = {}

const REQUIRED_APP_FLAGS: AppFlagMapping = {}

export {
  APP_DATA_SECTION_MAPPING,
  APP_NAME_MAPPING,
  HEADER_ICON_MAPPING,
  HEADER_LIST,
  HEADER_MAPPING,
  INCLUDE_BANNER_LINK,
  SHOW_USER_INFO,
  SHOW_APPS_DROPDOWN,
  SHOW_ORG_SWITCHER,
  SHOW_ACCOUNT_SWITCHER,
  SHOW_PRODUCT_DROPDOWN,
  SHOW_NOTIFICATION_DROPDOWN,
  SUITE_NAME,
  URL_BUILDERS,
  URL_MAPPING,
  REQUIRED_APP_FLAGS
}
